/* lp-neurotype — step 2 of the unlock lander: who are you, and where next.

   THIS DECIDES WHERE A VISITOR'S MONEY GOES. It runs at the exact moment
   they have agreed to keep going, so there is no input it may answer with a
   broken string: either a working URL, or null so the caller can fall back
   to the section's own default. Nobody reaches a dead end.

   IT PRESERVES THE EXISTING QUERY STRING on purpose. Today every persona
   lands on the same hoodie page; later they land on ?view=lp-adhd and
   siblings. Appending our params must never eat the template selector,
   which is why this parses rather than concatenates.

   NOTHING HERE TOUCHES THE CART. The handle rides along in the URL and is
   mirrored into sessionStorage so the product page can colour its copy and
   order its gift strip. Kaching owns everything cart-related. */
(() => {
  'use strict';

  const buildDestination = (baseUrl, personaHandle, revealSlugs) => {
    if (typeof baseUrl !== 'string' || baseUrl.trim() === '') return null;

    const parts = baseUrl.split('?');
    const path = parts[0];
    const params = new URLSearchParams(parts[1] || '');

    if (typeof personaHandle === 'string' && personaHandle !== '') {
      params.set('cn_neuro', personaHandle);
    }

    const slugs = (Array.isArray(revealSlugs) ? revealSlugs : []).filter(
      (s) => typeof s === 'string' && s !== ''
    );
    if (slugs.length > 0) params.set('cn_gifts', slugs.join(','));

    const query = params.toString();
    return query === '' ? path : path + '?' + query;
  };

  window.lpNeurotype = { buildDestination };

  /* ------------------------------------------------------------ controller */

  const track = (step) => {
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: 'lp_step_view', step: step });
    } catch (e) {
      /* Analytics never blocks the flow. */
    }
  };

  const init = (root) => {
    const options = Array.from(root.querySelectorAll('[data-lp-neurotype-option]'));
    const cta = root.querySelector('[data-lp-neurotype-continue]');
    if (options.length === 0 || !cta) return;

    const fallback = root.getAttribute('data-fallback') || '/products/the-stim-hoodie';
    let slugs = [];
    let chosen = null;

    document.addEventListener('lp:flip-complete', (event) => {
      slugs = (event.detail && event.detail.slugs) || [];
      root.hidden = false;
      track('neurotype');
    });

    options.forEach((option) => {
      option.addEventListener('click', () => {
        options.forEach((o) => o.setAttribute('aria-checked', 'false'));
        option.setAttribute('aria-checked', 'true');
        chosen = option;
        cta.disabled = false;
      });
    });

    cta.addEventListener('click', () => {
      if (!chosen) return;

      const handle = chosen.getAttribute('data-handle') || '';
      const base = chosen.getAttribute('data-destination') || fallback;

      /* Safari private mode throws on storage. A lost mirror is an ordinary
         state — the URL still carries everything — so it must never block
         the one action the visitor actually asked for. */
      try {
        window.sessionStorage.setItem(
          'cn_flow',
          JSON.stringify({ neuro: handle, gifts: slugs })
        );
      } catch (e) {
        /* no-op */
      }

      /* Klaviyo only attaches a property to a profile it can already
         identify — an existing subscriber, or a returning cookied visitor.
         On cold traffic this queues and mostly evaporates, which is why the
         load-bearing capture is the order attribute, not this. */
      try {
        window._learnq = window._learnq || [];
        window._learnq.push(['track', 'Selected Neurotype', { Neurotype: handle }]);
      } catch (e) {
        /* no-op */
      }

      window.location.href = buildDestination(base, handle, slugs) || fallback;
    });
  };

  const boot = () => {
    document.querySelectorAll('[data-lp-neurotype]').forEach(init);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
